import React, { Component } from "react";
import { connect } from "react-redux";

import { createRole } from "actions/role";
import { fetchPermissions } from "actions/permission";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Role/Form/index";
import { permissions } from "reducers/permission";

class RoleCreate extends Component {
  componentDidMount() {
    this.props.fetchPermissions({ limit: 999 });
  }
  handleFormSubmit = data => {
    this.createRole(data);
  };

  createRole(data) {
    const { toggleNotification, toggleFullPageSpinner, createRole, history } = this.props;
    toggleFullPageSpinner(true);
    createRole(data)
      .then(() => {
        toggleNotification(true, { message: "Created Role Success", infoClassName: "is-success" });
        history.push(`/roles`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} permissions={this.props.permissions} />;
  }
}

export default connect(
  permissions,
  {
    createRole,
    fetchPermissions,
    toggleFullPageSpinner,
    toggleNotification
  }
)(RoleCreate);



// WEBPACK FOOTER //
// ./src/pages/Role/Create/index.js